'use client';

import { useEffect } from 'react';
import { PROFILE_DRAWER_OPEN_PARAM, PROFILE_DRAWER_OPEN_PARAM_VALUE } from '../profile-drawer.constants';

type UseProfileDrawerOpenParamArgs = {
    browserHistory?: Pick<History, 'replaceState'>;
    browserLocation?: Pick<Location, 'hash' | 'pathname' | 'search'>;
    setOpen: (open: boolean) => void;
};

export const useProfileDrawerOpenParam = ({
    browserHistory,
    browserLocation,
    setOpen,
}: UseProfileDrawerOpenParamArgs): void => {
    useEffect(() => {
        const resolvedLocation = browserLocation ?? (typeof window !== 'undefined' ? window.location : undefined);
        const resolvedHistory = browserHistory ?? (typeof window !== 'undefined' ? window.history : undefined);

        if (!resolvedLocation) {
            return;
        }

        const params = new URLSearchParams(resolvedLocation.search);

        if (params.get(PROFILE_DRAWER_OPEN_PARAM) !== PROFILE_DRAWER_OPEN_PARAM_VALUE) {
            return;
        }

        params.delete(PROFILE_DRAWER_OPEN_PARAM);
        setOpen(true);

        if (!resolvedHistory) {
            return;
        }

        const search = params.toString();
        const nextUrl = `${resolvedLocation.pathname}${search ? `?${search}` : ''}${resolvedLocation.hash}`;
        resolvedHistory.replaceState(null, '', nextUrl);
    }, [browserHistory, browserLocation, setOpen]);
};
